import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, PropType } from 'vue';
import BaseModal from './BaseModal.vue';
import InvitePatientModal from './InvitePatientModal.vue';
import AssignToOrgModal from './AssignToOrgModal.vue';
import AssignToTeamModal from './AssignToTeamModal.vue';
import ReviewMeasurementsModal from './ReviewMeasurementsModal.vue';
import DischargeProgramModal from './DischargeProgramModal.vue';
import PatientSettingsModal from './PatientSettingsModal.vue';
import SetNextConsultModal from './SetNextConsultModal.vue';
import { FEATURES } from '@/constants';
import { isFeatureFlagEnabled } from '@/helpers/feature-flag.helper';
import { CopdProgramConsult, CopdProgramReviewConsult, CopdProgramSetting, Organisation, Patient, Tag, Worklist } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientHomeMonitoringActionModal',
  props: {
  patient: {
    type: Object as PropType<Patient>,
    required: true
  },
  assignedOrg: {
    type: Object as PropType<Organisation | null>,
    default: null
  },
  assignedCommunityTeam: {
    type: Object as PropType<Tag | null>,
    default: null
  },
  assignedHospitalTeam: {
    type: Object as PropType<Tag | null>,
    default: null
  },
  onHomeMonitoring: {
    type: Object as PropType<Tag | null>,
    default: null
  },
  programId: {
    type: String,
    required: true
  },
  status: {
    type: String,
    required: true
  },
  toBeReviewedList: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  nextConsult: {
    type: Object as PropType<CopdProgramReviewConsult | CopdProgramConsult | null>,
    default: null
  },
  settings: {
    type: Object as PropType<CopdProgramSetting>,
    required: true
  },
  worklist: {
    type: Object as PropType<Worklist>,
    default: () => null
  }
},
  emits: ["close", "discharged", "update-invitation-banner", "record-event", "update-assigned-org", "update:assigned-hospital-team", "update:assigned-community-team"],
  setup(__props) {




const tagsFeatureFlag = computed<boolean>(() => isFeatureFlagEnabled(FEATURES.TAGS));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (__props.status === 'invite')
        ? (_openBlock(), _createBlock(InvitePatientModal, _mergeProps({
            key: 0,
            patient: __props.patient
          }, _ctx.$attrs, {
            onUpdateInvitationBanner: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-invitation-banner')))
          }), null, 16, ["patient"]))
        : (__props.status === 'assign' && !tagsFeatureFlag.value)
          ? (_openBlock(), _createBlock(AssignToOrgModal, _mergeProps({
              key: 1,
              "program-id": __props.programId
            }, _ctx.$attrs, {
              onRecordEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('record-event', $event))),
              onUpdateAssignedOrg: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-assigned-org', $event))),
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            }), null, 16, ["program-id"]))
          : (__props.status === 'assign' && tagsFeatureFlag.value)
            ? (_openBlock(), _createBlock(AssignToTeamModal, _mergeProps({
                key: 2,
                "program-id": __props.programId,
                "assigned-org": __props.assignedOrg,
                "assigned-community-team": __props.assignedCommunityTeam,
                "assigned-hospital-team": __props.assignedHospitalTeam
              }, _ctx.$attrs, {
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close'))),
                onRecordEvent: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('record-event', $event))),
                onUpdateAssignedOrg: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update-assigned-org', $event))),
                "onUpdate:assignedHospitalTeam": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:assigned-hospital-team', $event))),
                "onUpdate:assignedCommunityTeam": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:assigned-community-team', $event)))
              }), null, 16, ["program-id", "assigned-org", "assigned-community-team", "assigned-hospital-team"]))
            : (__props.status === 'review')
              ? (_openBlock(), _createBlock(ReviewMeasurementsModal, _mergeProps({
                  key: 3,
                  patient: __props.patient,
                  status: __props.status,
                  "to-be-reviewed-list": __props.toBeReviewedList,
                  "program-id": __props.programId,
                  "next-consult": __props.nextConsult as CopdProgramReviewConsult,
                  worklist: __props.worklist
                }, _ctx.$attrs, {
                  onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close', $event))),
                  onRecordEvent: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('record-event', $event))),
                  onDischarged: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('discharged')))
                }), null, 16, ["patient", "status", "to-be-reviewed-list", "program-id", "next-consult", "worklist"]))
              : (__props.status === 'settings')
                ? (_openBlock(), _createBlock(PatientSettingsModal, _mergeProps({
                    key: 4,
                    "current-settings": __props.settings,
                    "program-id": __props.programId,
                    "on-home-monitoring": __props.onHomeMonitoring
                  }, _ctx.$attrs, {
                    onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close', $event)))
                  }), null, 16, ["current-settings", "program-id", "on-home-monitoring"]))
                : (__props.status === 'discharge')
                  ? (_openBlock(), _createBlock(DischargeProgramModal, _mergeProps({
                      key: 5,
                      status: __props.status,
                      "program-id": __props.programId,
                      worklist: __props.worklist,
                      patient: __props.patient
                    }, _ctx.$attrs, {
                      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close', $event))),
                      onRecordEvent: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('record-event', $event))),
                      onDischarged: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('discharged', $event)))
                    }), null, 16, ["status", "program-id", "worklist", "patient"]))
                  : (__props.status === 'consult')
                    ? (_openBlock(), _createBlock(SetNextConsultModal, _mergeProps({
                        key: 6,
                        "program-id": __props.programId,
                        "next-consult": __props.nextConsult as CopdProgramConsult
                      }, _ctx.$attrs, {
                        onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('close', $event)))
                      }), null, 16, ["program-id", "next-consult"]))
                    : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})